import { Wrap, Button } from "@chakra-ui/react";
import { usePeople } from "../data/people";

export const PeoplesNames = () => {
  const { people, updatePerson } = usePeople();

  return (
    <Wrap
      p={4}
      spacing={[2, 4]}
      fontSize="16px"
      fontFamily="Menlo, mono"
      justify="center"
    >
      {people
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((person) => (
          <Button
            key={person.id}
            onClick={() => {
              updatePerson(person.id, {
                hasGone: !person.hasGone,
              });
            }}
            cursor="pointer"
            py={1}
            px={2}
            outline={0}
            rounded="md"
            justifyContent="center"
            display="flex"
            variant="ghost"
            size="xl"
            fontWeight="normal"
            textTransform="lowercase"
            textDecor={person.hasGone ? "line-through" : undefined}
            textDecorationThickness={3 as any}
            _focus={{ outline: 0 }}
            boxSizing="border-box"
            _focusVisible={{ bgColor: "blackAlpha.50" }}
            _hover={{ bgColor: "blackAlpha.50" }}
          >
            {person.name}
          </Button>
        ))}
    </Wrap>
  );
};
